import {
  FaBaby, FaBinoculars, FaCoffee, FaFilm, FaLandmark, FaPalette,
  FaRunning, FaShoppingBag, FaStore, FaTree, FaUtensils,
} from "react-icons/fa";
import { GiCastle, GiGreekTemple, GiMartini } from "react-icons/gi";

export const STOP_CATEGORIES = [
  { id: "landmarks", label: "Landmarks", singular: "Landmark", icon: FaLandmark, color: "#7c3aed" },
  { id: "museums", label: "Museums", singular: "Museum", icon: GiGreekTemple, color: "#9333ea" },
  { id: "galleries", label: "Galleries", singular: "Gallery", icon: FaPalette, color: "#db2777" },
  { id: "parks", label: "Parks & nature", singular: "Nature", icon: FaTree, color: "#15803d" },
  { id: "cafes", label: "Cafés", singular: "Café", icon: FaCoffee, color: "#a16207" },
  { id: "food", label: "Food", singular: "Food", icon: FaUtensils, color: "#ea580c" },
  { id: "shopping", label: "Shopping", singular: "Shopping", icon: FaShoppingBag, color: "#0369a1" },
  { id: "markets", label: "Markets", singular: "Market", icon: FaStore, color: "#0f766e" },
  { id: "family", label: "Family", singular: "Family", icon: FaBaby, color: "#2563eb" },
  { id: "entertainment", label: "Entertainment", singular: "Entertainment", icon: FaFilm, color: "#c026d3" },
  { id: "scenic", label: "Scenic", singular: "Scenic", icon: FaBinoculars, color: "#0d9488" },
  { id: "activities", label: "Activities", singular: "Activity", icon: FaRunning, color: "#ca8a04" },
  { id: "bars", label: "Bars & pubs", singular: "Bar or pub", icon: GiMartini, color: "#b45309" },
  { id: "heritage", label: "History & heritage", singular: "Historic place", icon: GiCastle, color: "#9f1239" },
];

export const DEFAULT_QUANTITIES = Object.fromEntries(
  STOP_CATEGORIES.map(({ id }) => [id, id === "landmarks" ? 2 : ["museums", "parks"].includes(id) ? 1 : 0]),
);

export const categoryDetails = (id) => STOP_CATEGORIES.find((item) => item.id === id) || STOP_CATEGORIES[0];

export const distributedCategories = (quantities) => {
  const remaining = STOP_CATEGORIES.map(({ id }) => ({ id, quantity: Math.max(0, Math.min(5, Number(quantities[id]) || 0)) }));
  const result = [];
  while (result.length < 10 && remaining.some(({ quantity }) => quantity > 0)) {
    remaining.forEach((item) => {
      if (item.quantity > 0 && result.length < 10) {
        result.push(item.id);
        item.quantity -= 1;
      }
    });
  }
  return result;
};
